import { Stack } from '@mui/material';
import { Edit } from './Edit';
import { CriteriaFilter } from './CriteriaFilter';
import { useIsDesktop } from 'Hooks';
import { useContext } from 'react';
import { SuppliersContext } from 'Context/SuppliersContext';
import { SUPPLIERS_STEPS } from 'Enum/suppliers';

export const DynamicAdvancedCriteriaFilter = () => {
  const { setStepIndex } = useContext(SuppliersContext);
  const isDesktop = useIsDesktop();

  return (
    <Stack
      direction='row'
      justifyContent='space-between'
      alignItems='center'
      sx={{
        position: 'relative',
        p: isDesktop ? '16px 24px 16px 8px' : '6px 16px 8px 12px',
        height: isDesktop ? '64px' : '72px',
        bgcolor: '#FFFFFF',
        border: '1px solid',
        borderColor: 'purple2.main',
        borderRadius: '10px',
      }}
      onClick={
        isDesktop
          ? undefined
          : (event) => {
              event.stopPropagation();
              setStepIndex(SUPPLIERS_STEPS.FORM);
            }
      }
    >
      <CriteriaFilter />
      <Edit />
    </Stack>
  );
};
